import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import BookingRequestList from './components/BookingRequestList'
import TrainerAvailablityCalendarList from './components/TrainerAvailabilityCalendarList'
import PersonalAvailabilityCalendar from './PersonalAvailabilityCalendar'
import NewBookingCalendar from './components/NewBookingCalendar'
import GroupBookingReservationList from './components/GroupBookingReservationList'

const bookingBreadcrumbs: Array<PageLink> = [
  {
    title: 'Booking',
    path: '/bookings/requests',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const BookingsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='requests/*'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Booking'}></DocumentTitle>
              <PageTitle breadcrumbs={bookingBreadcrumbs}>Bookings</PageTitle>
              <BookingRequestList />
            </>
          }
        />
        <Route
          path='group_reservations/*'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Group Reservations'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={bookingBreadcrumbs}>Group Reservations</PageTitle>
              <GroupBookingReservationList />
            </>
          }
        />

        <Route
          path='trainer-availability-calendars'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Booking'}></DocumentTitle>
              <PageTitle breadcrumbs={bookingBreadcrumbs}>Availability List View</PageTitle>
              <TrainerAvailablityCalendarList />
            </>
          }
        />
        <Route
          path='personal-available-calendar'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Booking'}></DocumentTitle>
              <PageTitle breadcrumbs={bookingBreadcrumbs}>Availability Calendar</PageTitle>
              <PersonalAvailabilityCalendar />
            </>
          }
        />
        <Route
          path='calendar'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Booking'}></DocumentTitle>
              <PageTitle breadcrumbs={bookingBreadcrumbs}>Booking Calendar</PageTitle>
              <NewBookingCalendar />
            </>
          }
        />
        <Route index element={<Navigate to='/boookings/requests' />} />
      </Route>
    </Routes>
  )
}

export default BookingsPage
